import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BtnSmallComponent } from './btn-small.component';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    BtnSmallComponent
  ],
  exports: [
    BtnSmallComponent
  ]
})
export class BtnSmallModule { }
